/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import NavItemTooltip from '../NavItemTooltip';

import t from '../../../../../../../../css/global.module.css';
import s from './navItemProfile.module.css';


const NavItemProfileTooltip = (props) => {
  let notifs = '';
  if (props.actionsTotalCount > 0) {
    notifs = <div className={`${t.b} ${s.flag} ${s.flagProfile}`}>{props.actionsTotalCount}</div>;
  }

  return (<NavItemTooltip {...props} notifs={notifs} />);
};

NavItemProfileTooltip.propTypes = {
  actionsTotalCount: PropTypes.number,
  data: PropTypes.shape({
    ...NavItemTooltip.propTypes.data,
  }).isRequired,
};

NavItemProfileTooltip.defaultProps = {
  actionsTotalCount: 0,
};

export default NavItemProfileTooltip;
